// https://gist.github.com/oboshto/ad43eb606acdc133aa773fc5cf4e64b1
export function debounce(fn, delay) {
    let timer;
    function returnFunc(...args) {
        const context = this;
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    }
    return returnFunc;
}
/**
 * A throttle implementation which invokes `fn` at the leading edge of the period,
 * but not again at the end; i.e. subsequent calls within `periodMs` are discarded.
 */
export function throttleLeading(fn, periodMs) {
    let waiting = false;
    return function returnFunc(...args) {
        if (!waiting) {
            fn.apply(this, args);
            waiting = true;
            setTimeout(() => {
                waiting = false;
            }, periodMs);
        }
    };
}
/**
 * A throttle implementation which invokes `fn` at the leading edge of the period,
 * and, if `returnFunc` is subsequently invoked during `periodMs`, will schedule
 * an invocation of `fn` for the end of `periodMs`. In the event that `returnFunc`
 * is called multiple times within `periodMs`, the scheduled call will use the
 * latest arguments provided to `returnFunc`.
 */
export function throttleTrailing(fn, periodMs) {
    let lastInvocationTime = 0;
    let timer;
    let latestScope;
    let latestArgs;
    function invokeFn() {
        clearTimeout(timer);
        timer = undefined;
        lastInvocationTime = Date.now();
        fn.apply(latestScope, latestArgs);
    }
    return function returnFunc(...args) {
        latestScope = this;
        latestArgs = args;
        if (timer) {
            return;
        }
        const timeSinceLastInvocation = Date.now() - lastInvocationTime;
        const timeoutMs = lastInvocationTime
            ? Math.max(periodMs - timeSinceLastInvocation, 0)
            : 0;
        if (timeoutMs) {
            timer = setTimeout(invokeFn, timeoutMs);
        }
        else {
            invokeFn();
        }
    };
}
